import React from 'react';
import { Transfers } from './Components/Transfers/Transfers';
import { TransferTableType } from './Components/Transfers/Transfers.meta';

interface Props {
  managedAccountId: string;
}

export const TransfersStatus: React.FC<Props> = ({ managedAccountId }) => (
  <>
    <Transfers
      managedAccountId={managedAccountId}
      transferTableType={TransferTableType.Scheduled}
    />

    <Transfers managedAccountId={managedAccountId} transferTableType={TransferTableType.Pending} />

    <Transfers managedAccountId={managedAccountId} transferTableType={TransferTableType.Rejected} />
  </>
);
